export default __webpack_public_path__ + "static/media/fundo_edicao_rid.09df2633.png";